export enum AdminSettingsSection {
	Cards = 'Cards',
	Company = 'Company',
	BrandSettings = 'BrandSettings',
	GoogleReviewBrandingPreferences = 'GoogleReviewBrandingPreferences',
	AICustomContent = 'AICustomContent',
	Defaults = 'Defaults',
	Meetings = 'Meetings',
	Blog = 'Blog',
	UsersAndBilling = 'UsersAndBilling',
	UserGroups = 'UserGroups',
	ReceivePayments = 'ReceivePayments',
}
